import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

(() => {
  const gtmScript = document.createElement('script');
  gtmScript.innerHTML = `(function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', '${environment.googleTagManagerId}');`;

  const gaScript = document.createElement('script');
  gaScript.innerHTML = `(function (w, d, s, i) {
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s);
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtag/js?id=' + i;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', '${environment.googleAnalyticsTrackingId}');`;

  const gaDatalayerScript = document.createElement('script');
  gaDatalayerScript.innerHTML = `window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  };
  gtag('js', new Date());
  gtag('config', '${environment.googleAnalyticsTrackingId}');`;

  document.head.appendChild(gaDatalayerScript);
  document.head.appendChild(gaScript);
  document.head.appendChild(gtmScript);

  const gtmNoScript = document.createElement('noscript');
  gtmNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${environment.googleTagManagerId}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.prepend(gtmNoScript);
})();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));